import { useMutation } from 'react-query';
import axios from 'axios';
import { backendURL, debug } from '../App';
import consoleLog from '../helpers/consoleLog';

const removeMemberAbsense = async ({ userID, clientID }) => {
  try {
    const { data } = await axios({
      method: 'post',
      url: `${backendURL}admin/members/${clientID}/`,
      headers: {
        Authorization: `Token ${localStorage.getItem('skillsSurveyUserToken')}`,
      },
      data: {
        user_id: userID,
        client_id: clientID,
        remove_fail: true
      },
    });
    debug && consoleLog('success', 'Remove member absence', data);
    return data;
  } catch (error) {
    debug && consoleLog('error', 'Remove member absence', error);
  }
};

export default function useRemoveMemberAbsenseutation({onSuccess}) {
  return useMutation(removeMemberAbsense, {onSuccess});
}
